export const PREVIEW_CONTAINER_BREAKPOINTS = {
  wide: 236,
  tablet: 211.5,
  medium: 192,
  phone: 153.25,
  compact: 122,
  row: 92,
  dialogMedium: 200,
  dialogCompact: 132,
} as const;
